import { Provider as JotaiProvider } from "jotai";
import type React from "react";
import RouterProvider from "./providers/routing/RouterProvider.tsx";
import SzQueryClientProvider from "./providers/routing/SzQueryClientProvider.tsx";
import SzThemeProvider from "./providers/theme/SzThemeProvider.tsx";

/**
 * Main `App` component with all providers and wrappers for the whole app
 * if you need a wrapper or provider either own or library do so here.
 * I'd recommend creating a new Provider within the Providers folder with children as prop
 * and then implementing it here, so that the logic is separated, manageable and readable.
 * @constructor
 */
const App: React.FC = () => (
	<JotaiProvider>
		<SzThemeProvider>
			<SzQueryClientProvider>
				<RouterProvider />
			</SzQueryClientProvider>
		</SzThemeProvider>
	</JotaiProvider>
);

export default App;
